import React from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';

function PrivacyPolicy({ onClose }) {
  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>Privacy Policy</h2>
          <button style={styles.closeButton} onClick={onClose}>×</button>
        </div>
        
        <div style={styles.content}>
          <p style={styles.paragraph}>
            FOI Group, LLC and its subsidiaries and affiliates (collectively, "FOIG") respect your right to privacy. This Privacy Policy ("Policy") describes the personal information FOIG may collect, use, disclose and otherwise process about individuals, as well as the rights and choices individuals may have regarding their personal information and other important topics relating to your privacy and data protection.
          </p>

          <p style={styles.paragraph}>
            FOIG's policy is to comply with all applicable privacy and data protection laws. This commitment reflects the value we place on earning and keeping the trust of our customers, business partners and others whose personal information we process.
          </p>

          <h3 style={styles.sectionTitle}>General Principles of FOI Group LLC's Collection, Use and Disclosure of Personal Information</h3>
          
          <p style={styles.paragraph}>
            To the extent required by applicable privacy and data protection law, whenever FOIG collects personal information, FOIG will:
          </p>

          <ul style={styles.list}>
            <li style={styles.listItem}>provide timely and appropriate notice to you about our data practices;</li>
            <li style={styles.listItem}>collect your personal information only for specified and legitimate purposes;</li>
            <li style={styles.listItem}>process your personal information in a manner consistent with the purposes for which it was originally collected;</li>
            <li style={styles.listItem}>take commercially reasonable steps to ensure that your personal information is reliable for its intended use;</li>
            <li style={styles.listItem}>not use your personal information for direct marketing purposes without giving you an opportunity to "opt-out";</li>
            <li style={styles.listItem}>take appropriate measures to provide adequate protection for personal information that is disclosed to a third party.</li>
          </ul>

          <h3 style={styles.sectionTitle}>Personal Information FOI Group, LLC Collects</h3>
          
          <h4 style={styles.subTitle}>Information You Provide</h4>
          <p style={styles.paragraph}>
            FOIG collects personal information you provide us, which may include: contact information, additional information about you, comments and questions, financial information, log-in information, and information about your preferences.
          </p>

          <h4 style={styles.subTitle}>Information Automatically Gathered from Your Device</h4>
          <p style={styles.paragraph}>
            FOIG may collect personal information related to your device, such as device type, browser type, IP address, operating system, and device identifier when you interact with FOIG Services.
          </p>

          <h3 style={styles.sectionTitle}>Security of Your Personal Information</h3>
          <p style={styles.paragraph}>
            FOIG maintains reasonable safeguards designed to protect the confidentiality, security, and integrity of your personal information.
          </p>

          <h3 style={styles.sectionTitle}>Questions about this Policy</h3>
          <p style={styles.paragraph}>
            If you have any questions about this Policy, please email us at dmunson@foigroup.com or write to:
          </p>
          <p style={styles.paragraph}>
            FOI Group, LLC<br/>
            11105 Shady Trail, Suite 119<br/>
            Dallas, Texas 75229
          </p>

          <p style={styles.effectiveDate}>Effective Date: 12 August 2025</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
    padding: '20px',
  },
  modal: {
    backgroundColor: colors.white,
    borderRadius: '12px',
    maxWidth: '900px',
    width: '100%',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '30px 40px',
    borderBottom: '1px solid #E5E5E5',
  },
  title: {
    fontSize: '32px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    margin: 0,
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '40px',
    color: colors.textSecondary,
    cursor: 'pointer',
    padding: 0,
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    padding: '30px 40px',
    overflowY: 'auto',
  },
  paragraph: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.6',
    marginBottom: '20px',
  },
  sectionTitle: {
    fontSize: '24px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginTop: '30px',
    marginBottom: '15px',
  },
  subTitle: {
    fontSize: '18px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginTop: '20px',
    marginBottom: '10px',
  },
  list: {
    marginLeft: '20px',
    marginBottom: '20px',
  },
  listItem: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.6',
    marginBottom: '10px',
  },
  effectiveDate: {
    fontSize: '14px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginTop: '30px',
    fontStyle: 'italic',
  },
};

export default PrivacyPolicy;